import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  inject,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-search-input',
  standalone: true,
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputComponent implements AfterViewInit {
  @Input() placeholder = $localize`Search`;
  @Input() ariaLabel: string | null = null;
  @Output() valueChange = new EventEmitter<string>();
  @ViewChild('searchInput') searchInput!: ElementRef;

  public value = '';
  private cdr = inject(ChangeDetectorRef);

  // ngbModal by default focuses on the first focusable element in the modal.
  // We'll use a timeout to ensure the search input is blurred after the modal is opened.
  public ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.blur();
    }, 1);
  }

  public handleSearchChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(target.value);
  }

  public reset() {
    this.value = '';
    this.valueChange.emit('');
    this.cdr.markForCheck();
    this.searchInput.nativeElement.focus();
  }
}
